module.exports = __webpack_public_path__ + "img/07-11-02.d563d750.png";